<template>
  <div class="cover">
    <h1>{{ course.goal }}</h1>
    <h2>{{ course.curator }}</h2>
    <h3 v-if="course.date && course.location">{{ course.date }} // {{ course.location }}</h3>
  </div>
</template>

<script>
export default {
  name: 'app',
  props: ["course"]
}
</script>

<style scoped>
h1 {
font-family: 'NittiBold';
font-weight: 500;
font-size: 6em;
}
</style>



// WEBPACK FOOTER //
// src/components/CoverPage.vue